<main class="objects" style="height: 100%;">
    <div style="height: 100%; flex-direction: column; display: flex;">
        <!--
        <div class="search wrapper">
            <app-objekt-suche (objectSelected)="onObjectSelectedBySearch($event)" [showAllFields]="advancedObjSearch" style="width:100%"></app-objekt-suche>
        </div>
        -->
        <div class="flex-row objekte-wrapper">
            @let objectSearchViewType = objektSearchView$ | async;
            @let treeViewDisplaySettings = treeViewDisplaySettings$ | async;
            @if (objectSearchViewType && treeViewDisplaySettings) {
                <!-- TODO in 2.18.290 rename class with https://swissjira.atlassian.net/browse/EN-4409 set to version 2.18.290 -->
                <div [ngClass]="{'smallView': objectSearchViewType !== 1}" [ngStyle]="{'width': sideViewWidthStyle}"
                     class="block1_leftSide flex-col">
                    <div class="obj-search" [style.height]="objectSearchViewType == 1? treeViewDisplaySettings.height : '60%'">
                        <object-search (objectSelected)="onObjectSelectedBySearch($event)" [useDynamicObjectSource]="objectSearchViewType == 1"></object-search>
                    </div>
                    <div [style.height]="objectSearchViewType == 1? 'calc(100% - ' + treeViewDisplaySettings.height + ')' : '60%'">
                        @switch (objectSearchViewType) {
                            @case (1) {
                                <treeview (objectSelected)="onObjectSelectedByTree($event)" (searchObjNotFound)="searchObjNotFound($event)" [addedNewlyCreatedNode]="addNodeEventEmitter"
                                          [deleteNode]="deleteNodeEventEmitter" [hideNavBar]="true" [highlightObject]="selectObjectEventEmitter" [treeData$]="treeData$" [showStatusColorInTree]="showStatusColorInTree()"></treeview>
                            }
                            @case (7) {
                                <treeview (objectSelected)="onObjectSelectedByTree($event)" (searchObjNotFound)="searchObjNotFound($event)" [addedNewlyCreatedNode]="addNodeEventEmitter"
                                          [deleteNode]="deleteNodeEventEmitter" [hideNavBar]="true" [highlightObject]="selectObjectEventEmitter" [treeData$]="treeData$" [showStatusColorInTree]="showStatusColorInTree()"></treeview>
                            }
                            @case (5) {
                                <app-object-listview #treeviewComponent (objectSelected)="onObjectSelectedByTree($event)" [categoryMode]="false" [data]="dataSubject2"
                                                     [selectObjectEventEmitter]="selectObjectEventEmitter2"></app-object-listview>
                                <div style="padding: 0.25em">

                                </div>
                            }
                            @case (6) {
                                <app-object-listview #treeviewComponent (objectSelected)="onObjectSelectedByTree($event)" [categoryMode]="false" [data]="dataSubject2"
                                                     [selectObjectEventEmitter]="selectObjectEventEmitter2"></app-object-listview>
                                <div style="padding: 0.25em">

                                </div>
                            }
                            @default {
                                <!--lagacy views-->
                                <div class="tree-view" style="height: 100%">
                                    <ejs-listview #objListView (select)="listViewItemClicked($event)" [dataSource]="dataSourceObjListView" [fields]="fieldsObjView" cssClass='e-list-template'>
                                        <ng-template #template let-dataSource="">
                                            <div class="e-list-wrapper e-list-multi-line e-list-avatar">
                                                <div [style.background-image]="'url(' + dataSource.objectTypeImg + ')'" alt="img" class="e-avatar e-avatar-small"
                                                     style="background: #bcbcbc; background-repeat: no-repeat; background-size: contain"></div>
                                                <span class="e-list-item-header">{{ dataSource.objectNumber }}</span>
                                                <span class="e-list-content">{{ dataSource.description }}<br/>{{ dataSource.note4 }}</span>
                                            </div>
                                        </ng-template>
                                        <ng-template #groupTemplate let-dataSource="">
                                            <div>
                                                <span class="objectTypeDesc">{{ dataSource.items?.[0].objectTypeDesc }}</span>
                                                <span id="count"> | {{ dataSource.items.length }} Einträge</span>
                                            </div>
                                        </ng-template>
                                    </ejs-listview>

                                    <div style="padding: 0.25em">

                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
                <div class="spacer">
                    <div class="line">
                        <mat-icon (pan)="changePosition($event)" (panend)="panEnd()" class="drag-bubble" [ngStyle]="{'display': !treeViewDisplaySettings.activeTouchBubble ? 'none': 'block'}">
                            arrows_outward
                        </mat-icon>
                    </div>
                </div>
                <div class="container block1_rightSide">
                    <app-vinavon-button>
                        <ng-container *ngIf="objectSearchViewType == 1">
                            <button [disabled]="!helperService.isWebServiceAvailable()" [matMenuTriggerFor]="menu" class="medium" mat-fab matTooltip="{{ 'MAIN_APP_OBJECTS.erfassen' | translate}}"
                                    style="background-color: #ffffff">
                                <mat-icon class="low">add</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu" class="box-shadow" style="box-shadow: 1px 1px 1px 1px black;">
                                <button (click)="onNewObjekt()" [disabled]="!rechtObjektErstellen" mat-menu-item> {{ "MAIN_APP_OBJECTS.objekt" | translate }}</button>
                                <button (click)="onNewAuftrag()" [disabled]="!rechtObjektAuftragErstellen" mat-menu-item> {{ "MAIN_APP_OBJECTS.auftrag" | translate }}</button>
                                <button (click)="onNewProdAuftrag()" [disabled]="!rechtObjektProdAuftragErstellen" mat-menu-item> {{ "MAIN_APP_OBJECTS.prodauftrag" | translate }}</button>
                            </mat-menu>

                            <button (click)="onDelObjekt()" [disabled]="(!svcObjekte.getCurrentObjectID() || !helperService.isWebServiceAvailable() ) && !rechtObjektLoeschen" class="medium" mat-fab
                                    matTooltip="{{'MAIN_APP_OBJECTS.objektLöschen' | translate }}" style="background-color: #ffffff">
                                <mat-icon class="low">delete</mat-icon>
                            </button>
                        </ng-container>

                        <button (click)="makeItOffline()" [disabled]="!svcObjekte.getCurrentObjectID() || !helperService.isWebServiceAvailable()" class="medium" mat-fab
                                matTooltip="{{'MAIN_APP_OBJECTS.offline' | translate}}"
                                style="background-color: #ffffff">
                            <mat-icon class="low">wifi_off</mat-icon>
                        </button>

                        <button [disabled]="true" style="visibility: hidden">
                            <mat-icon class="low"></mat-icon>
                        </button>

                        <button (click)="onNewPencilNote()" [disabled]="!svcObjekte.getCurrentObjectID()" class="medium" mat-fab matTooltip="{{'MAIN_APP_OBJECTS.notizblatt' | translate}}"
                                style="background-color: #ffffff">
                            <mat-icon class="low">edit_note</mat-icon>
                        </button>


                        <ng-container *ngIf="desktopCameraMode">
                            <button (click)="openCameraDialog()" [disabled]="!svcObjekte.getCurrentObjectID()" class="medium" mat-fab matTooltip="{{'MAIN_APP_OBJECTS.fotoErstellen' | translate }}"
                                    style="background-color: #ffffff">
                                <mat-icon class="low">photo_camera</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="!desktopCameraMode">
                            <button (click)="file.click()" [disabled]="!svcObjekte.getCurrentObjectID()" class="medium" mat-fab matTooltip="{{'MAIN_APP_OBJECTS.fotoErstellen' | translate }}"
                                    style="background-color: #ffffff">
                                <mat-icon class="low">photo_camera</mat-icon>
                                <input #file (change)="saveImage($event, file)" [hidden]="true" accept="image/*" capture="user" type="file"/>
                            </button>
                        </ng-container>


                        <button (click)="uploader.click()" [disabled]="!svcObjekte.getCurrentObjectID() || !helperService.isWebServiceAvailable()" class="medium" mat-fab style="background-color: #ffffff">
                            <mat-icon class="low">upload_file</mat-icon>
                        </button>
                        <input #uploader (change)="uploadFilePDF($event)" hidden multiple type="file"/>

                        <button (click)="addSwissSoftRapport()" *ngIf="isVinaIntern" [disabled]="!svcObjekte.getCurrentObjectID()" class="medium" mat-fab
                                matTooltip="{{'MAIN_APP_OBJECTS.createRapport' | translate }}" style="background-color: #ffffff">
                            <mat-icon class="low">content_paste</mat-icon>
                        </button>

                        <button (click)="makeObjektRapport()" *ngIf="isVinaIntern" [disabled]="!svcObjekte.getCurrentObjectID()" class="medium" mat-fab
                                matTooltip="{{'MAIN_APP_OBJECTS.makeObjectRaport' | translate }}" style="background-color: #ffffff">
                            <mat-icon class="low">post_add</mat-icon>
                        </button>
                    </app-vinavon-button>
                    <div class="block1_content">
                        <ng-container #objektForm [formGroup]="formGrp" id="ngObjektForm">
                            <mat-accordion>
                                <mat-expansion-panel (opened)="setExpandStateObjektDetails(0)" [disabled]="!objectDataLoaded" [expanded]="expandStateObjektDetails === 0" class="swissMatExpansionPanel">
                                    <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight" style="padding: 0 8px 0 12px">
                                        <mat-panel-title>
                                            {{ "MAIN_APP_OBJECTS.OBJEKTDETAILS" | translate }}
                                            {{ getOfflineState() }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <mat-tab-group (selectedTabChange)="objDetailsTabChange($event)" dynamicHeight>
                                        <mat-tab label="{{ 'MAIN_APP_OBJECTS.objektdetails' | translate }}">
                                            <div style="display: flex">
                                                <mat-card appearance="outlined" class="mat-elevation-z4" style="flex: 1 1 50%;">
                                                    <ng-container *ngFor="let swissField of mySwissFieldsObjectDetailLinks">
                                                        <app-swiss-dynamic-form [swissField]="swissField" [ignoreStyling]="true"></app-swiss-dynamic-form>
                                                    </ng-container>
                                                </mat-card>
                                                <mat-card appearance="outlined" class="mat-elevation-z4" style="flex: 1 1 50%">
                                                    <ng-container *ngFor="let swissField of mySwissFieldsObjectDetailRechts">
                                                        <app-swiss-dynamic-form [swissField]="swissField" [ignoreStyling]="true"></app-swiss-dynamic-form>
                                                    </ng-container>
                                                </mat-card>
                                            </div>
                                        </mat-tab>
                                        <mat-tab label="{{'MAIN_APP_OBJECTS.produktionsbeschrieb' | translate}}">
                                            <ejs-richtexteditor #richTxtEditor1 (actionBegin)="rteActionBegin($event)" (change)="rteContentChange($event, 'manuDesc')" [height]="height"
                                                                [readonly]="!helperService.isWebServiceAvailable()" [toolbarSettings]="tools" [value]="currObjekt.manufacturingDescription  || ''"
                                                                formControlName="manuDesc"></ejs-richtexteditor>
                                        </mat-tab>
                                        <mat-tab label="{{ 'MAIN_APP_OBJECTS.notizen' | translate }}">
                                            <ejs-richtexteditor #richTxtEditor2 (actionBegin)="rteActionBegin($event)" (change)="rteContentChange($event, 'memo')" [height]="height"
                                                                [readonly]="!helperService.isWebServiceAvailable()"
                                                                [toolbarSettings]="tools" [value]="currObjekt!.memo  || ''" formControlName="memo"></ejs-richtexteditor>
                                        </mat-tab>
                                    </mat-tab-group>
                                </mat-expansion-panel>
                            </mat-accordion>
                            <mat-accordion *ngIf="(mySwissFieldsObjectExtensionLinks.length + mySwissFieldsObjectExtensionRechts.length) > 0">
                                <mat-expansion-panel (opened)="setExpandStateObjektErweiterung(0)" [disabled]="!objectDataLoaded" [expanded]="expandStateObjektErweiterung === 0"
                                                     class="swissMatExpansionPanel">
                                    <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight" style="padding: 0 8px 0 12px">
                                        <mat-panel-title> {{ "MAIN_APP_OBJECTS.OBJEKTERWEITERUNG" | translate }}</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div>
                                        <div style="display: flex">
                                            <mat-card appearance="outlined" class="mat-elevation-z4" style="flex: 1 1 50%">
											<span *ngFor="let swissField of mySwissFieldsObjectExtensionLinks" class="form-row">
												<app-swiss-dynamic-form [swissField]="swissField" [ignoreStyling]="true"></app-swiss-dynamic-form>
											</span>
                                            </mat-card>
                                            <mat-card appearance="outlined" class="mat-elevation-z4" style="flex: 1 1 50%">
											<span *ngFor="let swissField of mySwissFieldsObjectExtensionRechts" class="form-row">
												<app-swiss-dynamic-form [swissField]="swissField" [ignoreStyling]="true"></app-swiss-dynamic-form>
											</span>
                                            </mat-card>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </ng-container>

                        <mat-accordion>
                            <mat-expansion-panel (opened)="setExpandStateObjektAktivitaeten(0)" [disabled]="!objectDataLoaded" [expanded]="expandStateObjektAktivitaeten === 0"
                                                 class="swissMatExpansionPanel">
                                <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight" style="padding: 0 8px 0 12px">
                                    <mat-panel-title>
                                        {{ "MAIN_APP_OBJECTS.OBJEKT-AKTIVITÄTEN" | translate }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div>
                                    <div *ngIf="hasObjektDokus == 1" [style.overflow]="'auto'" style="max-height: 400px">
                                        <table [dataSource]="dataSourceObjektAktivitaeten" mat-table>
                                            <!-- Art Column -->
                                            <ng-container matColumnDef="doku_art">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.art" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    <div [style.background-image]="'url(/assets/obj_activity_icons/' + element.imageFile + ')'"
                                                         style="background-repeat: no-repeat; background-size: contain; height: 20px; width: 20px;"></div>
                                                </td>
                                            </ng-container>

                                            <!-- Datum Column -->
                                            <ng-container matColumnDef="doku_bearbeitet">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.datum" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    {{ formatDate(element.datum) }}
                                                </td>
                                            </ng-container>

                                            <!-- Beschreibung Column -->
                                            <ng-container matColumnDef="doku_desc">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.beschreibung" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    {{ element.description }}
                                                </td>
                                            </ng-container>

                                            <!-- Name Column -->
                                            <ng-container matColumnDef="doku_name">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.name" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    {{ element.lastName }}
                                                </td>
                                            </ng-container>

                                            <!-- Vorname Column -->
                                            <ng-container matColumnDef="doku_vorname">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.vorname" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    {{ element.firstName }}
                                                </td>
                                            </ng-container>

                                            <!-- Ansprechname Column -->
                                            <ng-container matColumnDef="doku_ansprechname">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.ansprechname" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    {{ element.ansprechName }}
                                                </td>
                                            </ng-container>

                                            <!-- Ansprechvorname Column -->
                                            <ng-container matColumnDef="doku_ansprechvorname">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.ansprechvorname" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    {{ element.ansprechVorname }}
                                                </td>
                                            </ng-container>

                                            <!-- Settings Menu Column -->
                                            <ng-container matColumnDef="menuBild">
                                                <th *matHeaderCellDef mat-header-cell style="text-align: center"></th>
                                                <td *matCellDef="let element" mat-cell style="text-align: center">
                                                    <button (click)="$event.stopPropagation()" *ngIf="element.art === 12" [matMenuTriggerFor]="anpaMenu" mat-icon-button>
                                                        <mat-icon>more_horiz</mat-icon>
                                                    </button>
                                                    <button (click)="$event.stopPropagation()" *ngIf="element.art !== 12" [matMenuTriggerFor]="objActMenu" mat-icon-button>
                                                        <mat-icon>more_horiz</mat-icon>
                                                    </button>
                                                    <mat-menu #anpaMenu="matMenu">
                                                        <button (click)="showImage(element)" mat-menu-item>
                                                            <mat-icon>photo</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.anzeigen" | translate }}
														</span>
                                                        </button>
                                                        <button (click)="downloadImage(element)" mat-menu-item>
                                                            <mat-icon>file_download</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.download" | translate }}
														</span>
                                                        </button>
                                                        <button (click)="editImage(element)" [disabled]="!helperService.isWebServiceAvailable()" mat-menu-item>
                                                            <mat-icon>brush</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.bearbeiten" | translate }}
														</span>
                                                        </button>
                                                        <button (click)="delImage(element)" [disabled]="!helperService.isWebServiceAvailable()" mat-menu-item>
                                                            <mat-icon>delete_forever</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.löschen" | translate }}
														</span>
                                                        </button>
                                                    </mat-menu>
                                                    <mat-menu #objActMenu="matMenu">
                                                        <button (click)="downloadDocument(element)" *ngIf="[1,16].includes(element.art)" mat-menu-item>
                                                            <mat-icon>file_download</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.download" | translate }}
														</span>
                                                        </button>
                                                        <button (click)="delActivity(element)" [disabled]="helperService.isWebServiceAvailable()" mat-menu-item>
                                                            <mat-icon>delete_forever</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.löschen" | translate }}
														</span>
                                                        </button>
                                                    </mat-menu>
                                                </td>
                                            </ng-container>

                                            <tr *matHeaderRowDef="displayedObjDokuColumns" mat-header-row></tr>
                                            <tr (click)="openDocument(row)" *matRowDef="let row; columns: displayedObjDokuColumns" [ngClass]="{ highlight: selectedObjektDocumentID == row.ID }"
                                                class="rowCursor" mat-row></tr>
                                        </table>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                        <mat-accordion>
                            <mat-expansion-panel (opened)="setExpandStateObjektAdressen(0)" [disabled]="!objectDataLoaded" [expanded]="expandStateObjektAdressen === 0" class="swissMatExpansionPanel">
                                <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight" style="padding: 0 8px 0 12px">
                                    <mat-panel-title>
                                        {{ "MAIN_APP_OBJECTS.OBJEKT-ADRESSEN" | translate }}
                                    </mat-panel-title>

                                </mat-expansion-panel-header>
                                <div>
                                    <div *ngIf="objectDataLoaded">
                                        <button (click)="addObjectAddress()" [disabled]="!helperService.isWebServiceAvailable()" class="block1_btn" mat-raised-button>
                                            <mat-icon class="material-icons block1_icon"> edit</mat-icon>
                                            {{ "MAIN_APP_OBJECTS.adresseHinzufügen" | translate }}
                                        </button>
                                    </div>
                                    <div *ngIf="hasObjektPartner == 1">
                                        <table [dataSource]="dataSourceObjektAdressen" mat-table>
                                            <!-- Typ Column -->
                                            <ng-container matColumnDef="adrtyp">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.typ" | translate }}
                                                </th>
                                                <td (click)="navigateToAddress(element)" *matCellDef="let element" mat-cell>
                                                    {{ element.addressTypeDescription }}
                                                </td>
                                            </ng-container>

                                            <!-- Name Column -->
                                            <ng-container matColumnDef="kombiname">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.name" | translate }}
                                                </th>
                                                <td (click)="navigateToAddress(element)" *matCellDef="let element" mat-cell>
                                                    {{ element.fullName }}
                                                </td>
                                            </ng-container>

                                            <!-- Strasse Column -->
                                            <ng-container matColumnDef="street">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.strasse" | translate }}
                                                </th>
                                                <td (click)="navigateToAddress(element)" *matCellDef="let element" mat-cell>
                                                    {{ element.street1 }}
                                                </td>
                                            </ng-container>

                                            <!-- Plz Column -->
                                            <ng-container matColumnDef="plz">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.plz" | translate }}
                                                </th>
                                                <td (click)="navigateToAddress(element)" *matCellDef="let element" mat-cell>{{ element.zip }}</td>
                                            </ng-container>

                                            <!-- Ort Column -->
                                            <ng-container matColumnDef="city">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.ort" | translate }}
                                                </th>
                                                <td (click)="navigateToAddress(element)" *matCellDef="let element" mat-cell>{{ element.city }}</td>
                                            </ng-container>

                                            <!-- Hauptnummer Column -->
                                            <ng-container matColumnDef="telefon">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.telefon" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    <a href="tel:{{ element.phone01 }}">{{
                                                            element.phone01
                                                        }}</a>
                                                </td>
                                            </ng-container>

                                            <!-- Anrede Column -->
                                            <ng-container matColumnDef="anrede">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.anrede" | translate }}
                                                </th>
                                                <td (click)="navigateToAddress(element)" *matCellDef="let element" mat-cell>
                                                    {{ element.attentionOf }}
                                                </td>
                                            </ng-container>

                                            <!-- Email Column -->
                                            <ng-container matColumnDef="email">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.email" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    <a href="mailto:{{ element.email }}">{{ element.email }}</a>
                                                </td>
                                            </ng-container>

                                            <!-- Natel Column -->
                                            <ng-container matColumnDef="natel">
                                                <th *matHeaderCellDef mat-header-cell>
                                                    {{ "MAIN_APP_OBJECTS.natel" | translate }}
                                                </th>
                                                <td *matCellDef="let element" mat-cell>
                                                    <a href="tel:{{ element.mobile }}">{{ element.mobile }}</a>
                                                </td>
                                            </ng-container>

                                            <!-- Settings Menu Column -->
                                            <ng-container matColumnDef="menuOA">
                                                <th *matHeaderCellDef mat-header-cell style="text-align: center"></th>
                                                <td *matCellDef="let element" mat-cell style="text-align: center">
                                                    <button [disabled]="!helperService.isWebServiceAvailable()" [matMenuTriggerFor]="anpaMenu" mat-icon-button>
                                                        <mat-icon>more_horiz</mat-icon>
                                                    </button>
                                                    <mat-menu #anpaMenu="matMenu">
                                                        <button (click)="delContactPersonLink(element)" mat-menu-item>
                                                            <mat-icon>delete_forever</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.adressverknüpfungLöschen" | translate }}</span>
                                                        </button>
                                                        <button (click)="changeContactPerson(element)" mat-menu-item>
                                                            <mat-icon>person_search</mat-icon>
                                                            <span>{{ "MAIN_APP_OBJECTS.adressPartnermutation" | translate }}</span>
                                                        </button>
                                                        <button (click)="copyAddressesOnSubObjects(element)" mat-menu-item>
                                                            <mat-icon>edit_note</mat-icon>
                                                            <span>{{
                                                                    "MAIN_APP_OBJECTS.adresseAufUnterobjekteUbernehmen" | translate
                                                                }}</span>
                                                        </button>
                                                    </mat-menu>
                                                </td>
                                            </ng-container>

                                            <tr *matHeaderRowDef="displayedObjAdrColumns" mat-header-row></tr>
                                            <tr *matRowDef="let row; columns: displayedObjAdrColumns" [ngClass]="{highlight: selectedObjektAdressID == row.adressID}" mat-row></tr>
                                        </table>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
            }
        </div>

    </div>
</main>
